import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { MonitoramentoDecisoesService } from '../../../../providers/monitoramento-decisoes-service';

@Component({
  selector: 'page-modal-pv-monitoramento-decisoes',
  templateUrl: 'modal-pv-monitoramento-decisoes.html'
})
export class ModalPreVisualizarMonitoramentoDecisoesPage {
  titulo: any;
  isJurisdicionado: any;
  listaDados: any;
  listaDadosBaixa: any = [];
  listaDadosReincidencia: any = [];
  listaDadosOutros: any = [];
  dataGeracao: any;
  loading: boolean = true;
  shownGroup: any = [];

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams,
    public monitoramentoDecisoesService: MonitoramentoDecisoesService,
    public alertCtrl: AlertController,
    public gestaoPcaService: GestaoPcaService) {

    this.dataGeracao = new Date();

    this.listarDados();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  listarDados() {
    this.monitoramentoDecisoesService.obterDeterminacoesCertificado().subscribe(
      data => {
        this.listaDados = data;

        if (this.listaDados != undefined && this.listaDados.lstMonitoramentoDecisoes != undefined && this.listaDados.lstMonitoramentoDecisoes.length > 0) {
          this.listaDadosBaixa = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.flBaixa == true);
          this.listaDadosReincidencia = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.flReincidencia == true);
          this.listaDadosOutros = this.listaDados.lstMonitoramentoDecisoes.filter((determinacao) => determinacao.flReincidencia == false && determinacao.flBaixa == false);
        }

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      }
    );
  }

  //  #region Métodos do Accordion
  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      let index = this.shownGroup.indexOf(group);
      this.shownGroup.splice(index, 1);
    } else {
      this.shownGroup.push(group);
    }
  }

  isGroupShown(group) {
    return this.shownGroup.indexOf(group) != -1;
  };
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/monitoramento-decisoes/modal-pv-monitoramento-decisoes.ts